import { render } from "./Trivia.vue?vue&type=template&id=def6ac7c&scoped=true"
import script from "./Trivia.vue?vue&type=script&lang=js"
export * from "./Trivia.vue?vue&type=script&lang=js"

import "./Trivia.vue?vue&type=style&index=0&id=def6ac7c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-def6ac7c"]])

export default __exports__